import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onUnmounted } from 'vue';
import UiCalendar from '../../components/calendar.vue';
import { type DayCell, type RangeDirection, type GroupingOption } from '../../datepicker';


const __default__ = {
    name: 'UiDatepickerDateRangePlus',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    cells: null,
    title: null,
    cells2: null,
    title2: null,
    rangeDirection: { default: null },
    showMonthPicker: { type: Boolean, default: false },
    viewYear: { default: 0 },
    viewMonth: { default: 0 },
    periodStr: { default: '' },
    presets: { default: () => [] },
    activePreset: { default: null },
    grouping: { default: undefined },
    groupingValue: { default: undefined }
  },
  emits: ["prev", "next", "toggle-month-picker", "day-click", "day-hover", "day-leave", "prev-year", "next-year", "select-view-month", "select-preset", "select-grouping", "reset", "apply"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'prev'): void;
    (e: 'next'): void;
    (e: 'toggle-month-picker'): void;
    (e: 'day-click', cell: DayCell): void;
    (e: 'day-hover', cell: DayCell): void;
    (e: 'day-leave'): void;
    (e: 'prev-year'): void;
    (e: 'next-year'): void;
    (e: 'select-view-month', idx: number): void;
    (e: 'select-preset', label: string): void;
    (e: 'select-grouping', value: string): void;
    (e: 'reset'): void;
    (e: 'apply'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { cells: DayCell[], title: string, cells2: DayCell[], title2: string, rangeDirection: RangeDirection, showMonthPicker: boolean, viewYear: number, viewMonth: number, periodStr: string, presets: string[], activePreset: string | null, grouping: GroupingOption[], groupingValue: string }





const groupingRef = ref<HTMLElement | null>(null);
const groupingOpen = ref(false);
const presetsRef = ref<HTMLElement | null>(null);
const presetsOpen = ref(false);

const groupingLabel = computed<string>(() => {
    const opts = props.grouping ?? [];
    return opts.find((o) => o.value === props.groupingValue)?.label ?? opts[0]?.label ?? '';
});

const togglePresets = (): void => {
    presetsOpen.value = !presetsOpen.value;
};

const choosePreset = (label: string): void => {
    emit('select-preset', label);
    presetsOpen.value = false;
};

const toggleGrouping = (): void => {
    groupingOpen.value = !groupingOpen.value;
};

const selectGrouping = (value: string): void => {
    emit('select-grouping', value);
    groupingOpen.value = false;
};

const handleDocumentClick = (): void => {
    groupingOpen.value = false;
    presetsOpen.value = false;
};

watch([groupingOpen, presetsOpen], ([grouping, presets]) => {
    if (grouping || presets) document.addEventListener('click', handleDocumentClick);
    else document.removeEventListener('click', handleDocumentClick);
});

onUnmounted(() => document.removeEventListener('click', handleDocumentClick));

return { __sfc: true,props, emit, groupingRef, groupingOpen, presetsRef, presetsOpen, groupingLabel, togglePresets, choosePreset, toggleGrouping, selectGrouping, handleDocumentClick, UiCalendar }
}

})